module.exports = __webpack_public_path__ + "static/Slice-8f8c39ce4b596560dd66a18f71ab363b.jpg";